// eslint-disable-next-line import/prefer-default-export
export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer ?
      reducer(state, action.payload) :
      state;
  };
}
